import styled from "styled-components";

export const StyledLink = styled.a`
  text-decoration: none;
  color: white;
`;

export const WhiteCard = styled.div`
  display: grid;
  gap: 1.2rem;
  margin-top: 1.2rem;
  grid-template-rows: auto;
  grid-template-columns: repeat(1, 1fr);
  /* min-height: 250px; */

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const TopText = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1600px;
  margin-bottom: 25px;

  @media (max-width: 1000px) {
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
`;

export const LeftText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RightText = styled.div`
  width: 40%;
  max-width: 445px;

  @media (max-width: 1000px) {
    width: 100%;
    max-width: none;
  }
`;

export const TypeBox = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  width: 40%;
  max-width: 400px;
  text-align: center;
  align-items: center;
  padding: 2rem 2rem;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  border-radius: 10px;

  @media (max-width: 1000px) {
    width: 100%;
    max-width: none;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    margin-bottom: 25px;
  }

  @media (max-width: 650px) {
    width: 300px;
    flex-direction: column;
    padding: 2rem 1rem;
  }
`;

export const BoxContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin-top: 30px;
  max-width: 1000px;

  @media (max-width: 1000px) {
    flex-direction: column;
  }

  @media (max-width: 650px) {
    align-items: center;
  }
`;

export const Overall = styled.div`
  display: flex;
  flex-direction: column;
  width: 85%;
  align-items: center;
  justify-content: flex-start;
  padding-top: 2rem;
  padding-bottom: 70px;
`;

export const ContactPara = styled.p`
  max-width: 600px;
  color: black;
  font-weight: 300;
  margin-top: 0;
  margin-bottom: 20px;
  display: inline-block;
  font-size: 14px;
  line-height: 22px;
  text-align: right;
  font-family: "Poppins", sans-serif;
  color: black;
  margin-top: 0px;
  margin-left: 0px;

  @media (max-width: 1000px) {
    width: 95%;
    text-align: center;
  }
`;

export const TypeInd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1000px) {
    width: 200px;
  }

  @media (max-width: 650px) {
    width: auto;
  }
`;

export const StyledListingForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1600px;
  justify-content: center;

  &label {
    margin-top: 10px;
  }
`;
export const AddressAndMap = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }
`;

export const MarginContainer = styled.div`
  margin-bottom: 1.5rem;
  position: relative;
  max-width: 100%;
`;
export const SmallerContainer = styled.div`
  margin-bottom: 1.5rem;
  position: relative;
  max-width: 23rem;
`;

export const NoMarginContainer = styled.div`
  position: relative;
  max-width: 100%;
`;

export const FullContainerAddListing = styled.div`
  margin-bottom: 20px;
  position: relative;
  width: 100%;
`;
/* .NewListing {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    align-items: center;
    margin: 100px 0;
}

.InputElement {
    font-family: sans-serif;
    font-size: 15px;

    line-height: 20px;
    padding-left: 15px;
    margin-bottom: 20px;
    border: 1px solid #eeeeee;
    
    display: block;
    width: 70%;    
    box-sizing: border-box;
} */

export const SwitchHolder = styled.div`
  display: flex;
  margin-top: 8px;
  justify-content: flex-start;
  align-items: center;
`;

export const InputImgHolder = styled.div`
  position: relative;
  flex-direction: column;
  border: 0.5px solid rgba(0, 0, 0, 0.1);
  width: 100%;
  background-color: white;
  padding: 10px 20px;
`;

export const HolderText = styled.div`
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
`;

export const CardHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  min-height: 100px;
  flex-wrap: wrap;
`;

export const ImgCard = styled.div`
  background-color: #f4f5f8;
  width: 195px;
  height: 145px;
  margin-right: 20px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  cursor: move;
  user-select: none;
  -webkit-user-select: none;
`;

export const ImgMore = styled.label`
  background-color: #f4f5f8;
  width: 195px;
  height: 145px;
  margin-right: 20px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;

  &:hover {
    cursor: pointer;
    background-color: #e0e0e2;
    transition: all 0.3s ease;
  }
`;

export const AddMore = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
`;

export const FlyerFilesHolder = styled.div`
  display: ${(props) => (props.submitFlyerFiles ? "flex" : "grid")};
  width: 100%;
  border: 0.5px solid rgba(0, 0, 0, 0.1);
  background-color: ${(props) => (props.submitFlyerFiles ? "#f5f5f5" : "#fff")};
  text-align: center;
  padding: 40px;
  margin-bottom: 10px;
  align-items: center;
  justify-content: center;

  @media (max-width: 500px) {
    padding: 10px;
  }
`;

export const LabelButton = styled.label`
  padding: 7px 12px;
  width: 200px;
  position: inherit;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;

  &:hover {
    cursor: pointer;
  }
`;

export const SmallFancy = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 1rem;
  /* margin-bottom: 0.5rem; */
  font-weight: 500;
`;

export const YoutubeVideo = styled.div`
  height: 180px;
  width: 320px;
  max-width: 100%;
  position: relative;
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
  background-image: url("https://d3e54v103j8qbb.cloudfront.net/static/youtube-placeholder.2b05e7d68d.svg");
  background-size: cover;
  background-position: 50% 50%;

  /* @media (max-width: 1600px) {
        height: 400px
    }

    @media (max-width: 1400px) {
        height: 350px
    }

    @media (max-width: 1100px) {
        height: 50vw;
    } */
`;

export const StyledForm = styled.form`
  /* max-width: 85vw; */
`;

export const FullContainer = styled.div`
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const UpgradeTop = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
`;

export const UpgradeDescriptionWrapper = styled.div`
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
`;

export const UpgradeMain = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
`;

export const UpgradeSub = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 1rem;
  font-weight: 500;
  opacity: 0.7;
  margin-bottom: 0.5rem;
`;

export const TwoPlans = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px;
`


export const LabelAndTooltip = styled.div`
    display: flex;
    align-items: center;
    /* margin-bottom: -8px; */
`
